import { api } from '@api'
import { UpdateTruckData } from '@types'

interface UpdateTruckResponse {
  message: string
}

const updateTrailer = async (trailerId: number, data: UpdateTruckData) => {
  const trailerData = {
    trailer: {
      description: data.description,
      equipmentType: data.equipmentType,
      disabled: data.disabled,
    },
  }
  const response = await api.put<UpdateTruckResponse>(`/trailers/${trailerId}`, trailerData)

  return response.data.message
}

export const TrailersApi = {
  updateTrailer,
}
